import type { MonthlyOccurrenceFormType } from './MonthlyOccurrenceForm';

export const toPayload = (formData: MonthlyOccurrenceFormType) => {
  return {
    lottery: {
      occurrence: {
        occurrenceType: 'MONTHLY',
        startDate: formData.startDate,
        endDate: formData.endDate,
      },
      drawDay: formData.drawDay,
      drawTime: formData.drawTime,
    } as const,
  };
};
